module.exports = __webpack_public_path__ + "static/media/Design_Service_Background.183d6dc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/Design_Service_Background.jpg
// module id = 1569
// module chunks = 0